<template>
  <v-form
  class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">Sign</h3>
    <p class="text-caption mb-4">Firmá con un certificado del keystore local (Alison Desktop).</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="pushGetSignature">
        Get Signature >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-select
            v-model="certificateSelected"
            :items="certificateList"
            item-title="cert.subject.DN"
            item-value="cert"
            label="Select Certificate"
            @update:modelValue="changeCertificate"
        ></v-select>
        <v-row>
          <v-col>
            <v-text-field
                v-model="text"
                label="DataToSign"
            ></v-text-field>
            <v-text-field
                v-model="selectKeystore"
                label="KeyStoreId"
            ></v-text-field>
            <v-autocomplete
                v-model="algorithm"
                :items="algorithmOPTIONS"
                label="Algorithm"
            ></v-autocomplete>
          </v-col>
          <v-col>
            <v-text-field
                v-model="params"
                label="Sign Params"
            ></v-text-field>
            <v-text-field
              v-model="certificate"
              label="Certificate"
          ></v-text-field>
            <v-autocomplete
              v-model="selectProfile"
              :items="profileOPTIONS"
              item-title="name"
              item-value="id"
              label="Profile"
          ></v-autocomplete>
            <v-select
              v-model="format"
              :items="formatItems"
              label="Format"
          ></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6">
        <v-textarea
              name="parameters"
            label="Parameters"
            no-resize
            height="400px"
            v-model="requestPayload"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <vue-json-pretty :rootPath="'res'" :data=this.response> </vue-json-pretty>
      </v-col>
    </v-row>

  </v-form>
</template>
<script>

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import * as testingData from '../datas/testingDatas.js'
import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'

  export default  {
    props: ['certList'],
    components: {
      VueJsonPretty,
    },
    data: () => ({
        text: '',
      dataToSignB64: null,
      certificate: null,
      certificateSelected: '',
      certificateList: [],
      signature: null,
      selectKeystore: null,
      selectProfile: '',
      algorithm: null,
      valid: true,
      format: null,
      params: null,
      formatItems: [],
      keystoresOPTIONS: [],
        algorithmOPTIONS: [],
      profileOPTIONS: [],
      requestPayload: '{}',
      response: null
    }),
    mounted(){
      this.certificateList= this.certList
      this.formatItems = Object.keys(testingData.signatureTypeOPTIONS)
      this.keystoresOPTIONS = this.objectToArray(testingData.keystoresOPTIONS)
      this.algorithmOPTIONS = this.objectToArray(testingData.algorithmOPTIONS)
      this.dataToSignB64 = [ 'bdc52be8192f6b0e01116d5a05aa12070643d15fd31ba524456e4e4587105b26'];
      this.updateRequest('dataToSignB64',null,this.dataToSignB64)
      this.updateRequest('algorithm',null,"SHA256withRSA")
    },
    watch: {
      selectKeystore(value){
        this.getKeyStoreInfo(value)
      },
      certList(){
        this.certificateList= this.certList
      },
      dataToSignB64(value) {
        this.updateRequest('dataToSignB64', null, value)
      },
      certificate(value){
        this.updateRequest('signingCertificate', 'thumbPrint', value)
      },
      selectKeystore(value){
        this.updateRequest('signingCertificate','keyStoreId', value)
      },
      selectProfile(value){
        this.updateRequest('signingCertificate','profileName', value)
      },
      algorithm(value){
        this.updateRequest('algorithm', null, value)
      },
      format(value){
        this.updateRequest('format', null, value)
      },
      params(value){
        this.updateRequest('extraParams', null, value)
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      updateRequest(key1, key2, param){
        let request = JSON.parse(this.requestPayload)
        if(key2){
          if(!request[key1]) request[key1] = {}
          request[key1][key2] = param;
        }else{
          request[key1] = param;
        }
        this.requestPayload = JSON.stringify(request, null, "\t");
      },
      pushSign() {
        if (this.$refs.form.validate()) {
          this.sign()
        }
      },
      pushGetSignature() {
        if (this.$refs.form.validate()) {
          this.getSignature()
        }
      },
      changeCertificate(cert){
        this.certificate = this.certificateSelected.thumbPrint
        this.selectKeystore = this.certificateSelected.keyStoreId
        this.selectProfile = this.certificateSelected.profile.name
      },
      sign() {
          alisonJS.sign(JSON.parse(this.requestPayload)).then((_signature) => {
                this.setColor('success')
                this.setSnack('Signed successfully')
            this.response = _signature;
            this.signature = JSON.stringify(_signature,null, "\t");
          })
      },
      getSignature() {
          alisonJS.getSignatures(JSON.parse(this.requestPayload)).then((result) => {
                this.setColor('success')
                this.setSnack('Signed successfully')
            this.response = result;
            this.signature = JSON.stringify(result,null, "\t");
          }, (e) => {
          this.setColor('error')
          if (e.code && (e.detail || e.message)) {
              if (e.message) {
                this.setSnack('ERROR ' + e.message)
              } else {
                this.setSnack('ERROR '+ e.code +': ' + e.detail)
              }
          } else {
            this.setSnack('FAILURE: ' + JSON.stringify(e))
          }
          this.response = e;
        })
      },
      objectToArray(objectValue){
        let newArray = []
        Object.keys(objectValue).forEach(element => {
          newArray.push({text: objectValue[element], value: element})
        });
        return newArray
      },
      getKeyStoreInfo(keystoreId) {
          alisonJS.keyStoreInfo({id:keystoreId}).then((info) => {
              this.setColor('info')
              this.setSnack('KeyStore info obtained successfully')
              this.profileOPTIONS = info.keyStore.profiles;
          }).catch(e=>{
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = e;
            this.response = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>
